// extracted by mini-css-extract-plugin
export var avatarContainer = "_ia-0";
export var avatarTypingWave = "_ia-i";
export var gray = "_ia-f";
export var green = "_ia-c";
export var icon = "_ia-9";
export var image = "_ia-1";
export var lg = "_ia-6";
export var md = "_ia-5";
export var presenceDot = "_ia-b";
export var red = "_ia-d";
export var sm = "_ia-4";
export var status = "_ia-a";
export var typingDot = "_ia-h";
export var typingPill = "_ia-g";
export var xl = "_ia-7";
export var xs = "_ia-3";
export var xxl = "_ia-8";
export var xxs = "_ia-2";
export var yellow = "_ia-e";